const MAX_SIZE = 30;
const RECENT_COUNT = 10;

const _buffer = [];

export function initErrorBuffer() {
  if (typeof window === "undefined") return;
  if (window.__bugReporterInit) return;
  window.__bugReporterInit = true;

  const origError = console.error.bind(console);
  console.error = (...args) => {
    _buffer.push({ level: "error", msg: args.map(String).join(" ") });
    if (_buffer.length > MAX_SIZE) _buffer.shift();
    origError(...args);
  };

  window.addEventListener("unhandledrejection", (e) => {
    const msg = e.reason
      ? e.reason.message || String(e.reason)
      : "Unhandled promise rejection";
    _buffer.push({ level: "rejection", msg });
    if (_buffer.length > MAX_SIZE) _buffer.shift();
  });
}

export function getRecentErrors() {
  return _buffer.slice(-RECENT_COUNT);
}
